import { teslaFleetAuthenticationCollection } from '@/reducers/teslaFleetAuthentication'

// Current scope from production: {"energy_cmds","energy_device_data","offline_access","openid","user_data","vehicle_charging_cmds","vehicle_cmds","vehicle_device_data","vehicle_location"}
const DEFAULT_SCOPE =
  'energy_cmds energy_device_data offline_access openid user_data vehicle_charging_cmds vehicle_cmds vehicle_device_data vehicle_location'

function getStaticRedirectUri(deviceType: 'vehicle' | 'energy_system') {
  if (deviceType === 'vehicle') {
    return (
      process.env.REACT_APP_TESLA_FLEET_REDIRECT_URI ??
      'https://optiwatt.com/tesla-authentication'
    )
  } else if (deviceType === 'energy_system') {
    return (
      process.env.REACT_APP_TESLA_POWERWALL_FLEET_REDIRECT_URI ??
      'https://optiwatt.com/tesla-authentication/energy-system'
    )
  } else {
    throw new Error(`Invalid device type: ${deviceType}`)
  }
}

/**
 * This function is to generate a reasonably working backup Tesla Fleet Auth URL.
 * It should ONLY be used in the case where we are missing the server response URL
 * from some reason. This just lets the user not be stuck and the button still works.
 */
export function generateStaticFleetUrl(
  deviceType: 'vehicle' | 'energy_system' = 'vehicle',
) {
  const SCOPE = process.env.REACT_APP_TESLA_FLEET_SCOPE || DEFAULT_SCOPE

  const generateRandomState = () => {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    return Array.from({ length: 10 }, () =>
      chars.charAt(Math.floor(Math.random() * chars.length)),
    ).join('')
  }

  // Default values to our production values in case they are not set. Allow overrides for local development.
  const data = {
    response_type: 'code',
    client_id:
      process.env.REACT_APP_TESLA_FLEET_CLIENT_ID ??
      '9da1edefb96f-4837-a344-a028d8fa7fcb',
    redirect_uri: getStaticRedirectUri(deviceType),
    scope: SCOPE,
    state: generateRandomState(),
  }

  const params = new URLSearchParams(data)
  return `https://fleet-auth.prd.vn.cloud.tesla.com/oauth2/v3/authorize?${params.toString()}`
}

function useFleetAuthUrl(deviceType: 'vehicle' | 'energy_system' = 'vehicle') {
  const { data, isLoadingOrIdle } = teslaFleetAuthenticationCollection.useFetch(
    {
      params: { device_type: deviceType },
    },
  )
  const teslaFleetAuthUrl = data?.[0]?.authorize_url
  const staticBackupFleetUrl = generateStaticFleetUrl(deviceType)

  return {
    url: teslaFleetAuthUrl ?? staticBackupFleetUrl,
    isLoading: isLoadingOrIdle,
  }
}

const FleetUtils = { generateStaticFleetUrl, useFleetAuthUrl }

export default FleetUtils
